export default __webpack_public_path__ + "static/media/new.73fe2647.png";